import * as React from 'react'
import classNames from 'classnames'
import { LucideIcon, LucideIconName } from 'utils/lucideIcon'
import { CONFIG } from 'capacity/copy'
import { CountingType } from 'capacity/types'

const COUNTING_TYPES: CountingType[] = ['wholeTimeSlot', 'arrivalOnly']

const icon: Record<CountingType, LucideIconName> = {
    wholeTimeSlot: 'Gauge',
    arrivalOnly: 'DoorOpen',
}

interface CountingTypeCardsProps {
    value: CountingType
    onChange: (value: CountingType) => void
}

export function CountingTypeCards({ value, onChange }: CountingTypeCardsProps) {
    return (
        <div className="capacity-counting-cards" role="group" aria-label={CONFIG.howItCountsQuestion}>
            {COUNTING_TYPES.map((option) => {
                const selected = value === option
                return (
                    <button
                        key={option}
                        type="button"
                        className={classNames('capacity-counting-card', { selected })}
                        aria-pressed={selected}
                        onClick={() => onChange(option)}
                    >
                        <span className="capacity-counting-icon">
                            <LucideIcon iconName={icon[option]} size={22} />
                        </span>
                        <span className="capacity-counting-lead">{CONFIG.counting[option].lead}</span>
                        <span className="capacity-counting-example">{CONFIG.counting[option].example}</span>
                    </button>
                )
            })}
        </div>
    )
}
